import { WithStyles, withStyles } from '@mui/styles';

import { Collateral } from './collateral';
import { muiStyles } from './collateralStyles';

export interface CollateralProps extends WithStyles<typeof muiStyles> {
    location: any;
}

export default withStyles(muiStyles)(Collateral);